module.exports = __webpack_public_path__ + "img/wallet-balance-icon.318cb723.svg";